import { render, staticRenderFns } from "./iLabel.vue?vue&type=template&id=3f2344ff&scoped=true"
import script from "./iLabel.vue?vue&type=script&lang=js"
export * from "./iLabel.vue?vue&type=script&lang=js"
import style0 from "./iLabel.vue?vue&type=style&index=0&id=3f2344ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2344ff",
  null
  
)

export default component.exports